// extracted by mini-css-extract-plugin
export default {"products_container":"Result_products_container__DGRVG"};